module.exports = __webpack_public_path__ + "static/media/energiankulutus-white.c17c7e74.svg";